// Padrón de socios: se lee en vivo desde la planilla de Google "Socios UIQ".
// Mariano edita la planilla y la web toma los cambios sola (sin publicar nada).
// La columna CUIT existe en la planilla pero NUNCA se muestra en la web.
// Si un dato está vacío en la planilla, en la web directamente no se muestra.

export const PADRON_SHEET_ID = '1zixpIxtoYUyixIMxBkVI9empXonMrsaXJWXrhALsz8g';
const CSV_URL = `https://docs.google.com/spreadsheets/d/${PADRON_SHEET_ID}/export?format=csv&gid=0`;

// Parser CSV (RFC 4180): soporta comillas, comas y saltos de línea dentro de una celda.
export function parseCSV(text) {
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i++; } else { inQuotes = false; }
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ',') {
      row.push(field); field = '';
    } else if (c === '\n' || c === '\r') {
      if (c === '\r' && text[i + 1] === '\n') i++;
      row.push(field); rows.push(row); row = []; field = '';
    } else {
      field += c;
    }
  }
  if (field !== '' || row.length) { row.push(field); rows.push(row); }
  return rows;
}

const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
const clean = (s) => {
  const v = (s || '').replace(/\s+/g, ' ').trim();
  return v === '-' || v === '—' ? '' : v;
};

function toUrl(raw) {
  const v = (raw || '').trim();
  if (!v || /\s/.test(v) || !v.includes('.')) return '';
  return /^https?:\/\//i.test(v) ? v : `https://${v}`;
}

export function socialLabel(url) {
  if (/instagram\.com/i.test(url)) return 'Instagram';
  if (/facebook\.com/i.test(url)) return 'Facebook';
  if (/linkedin\.com/i.test(url)) return 'LinkedIn';
  if (/(twitter|x)\.com/i.test(url)) return 'X';
  if (/youtube\.com/i.test(url)) return 'YouTube';
  return 'Red social';
}

export function rowsToSocios(rows) {
  if (!rows.length) return [];
  const header = rows[0].map(norm);
  const col = (...names) => header.findIndex((h) => names.includes(h));
  const iE = col('empresa', 'razon social', 'nombre');
  const iD = col('direccion', 'domicilio');
  const iL = col('localidad');
  const iR = col('rubro');
  const iA = col('actividad');
  const iW = col('web', 'sitio web', 'pagina web');
  const iS = col('redes', 'redes sociales');
  const get = (r, i) => (i >= 0 ? r[i] || '' : '');

  return rows
    .slice(1)
    .map((r) => {
      const empresa = clean(get(r, iE));
      if (!empresa) return null;
      const redes = get(r, iS)
        .split(/[\n,; ]+/)
        .map(toUrl)
        .filter(Boolean)
        .map((u) => ({ url: u, label: socialLabel(u) }));
      const s = {
        empresa,
        direccion: clean(get(r, iD)),
        localidad: clean(get(r, iL)),
        rubro: clean(get(r, iR)),
        actividad: (get(r, iA) || '').replace(/\r/g, '').trim().replace(/^-$/, ''),
        web: toUrl(get(r, iW)),
        redes,
      };
      s.busqueda = norm([s.empresa, s.rubro, s.actividad, s.localidad, s.direccion].join(' '));
      return s;
    })
    .filter(Boolean)
    .sort((a, b) => a.empresa.localeCompare(b.empresa, 'es'));
}

export async function fetchPadron() {
  const res = await fetch(`${CSV_URL}&t=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return rowsToSocios(parseCSV(await res.text()));
}

export const normalizar = norm;
